import { useEffect, useMemo, useRef, useState } from "react";

import { Options } from "ky";

import { useAPIToken } from "@ip-contexts/api-token-context";
import useFetch from "@ip-utils/use-fetch";

import { audiences, scopes } from "../../Routes";

const audience = audiences.tax ?? "";
const scope = Object.values(scopes).join(" ");

const prefixUrl = process.env.REACT_APP_API_TAX_URL;

export default function useFetchTax() {
  const permission = useMemo(
    () => ({
      audience,
      scope,
    }),
    []
  );

  const [isLoading, setIsLoading] = useState(true);
  const {
    state: { tokens, requestAccessToken, renewToken },
  } = useAPIToken();

  const [token, setToken] = useState<any>();

  const tokenRef = useRef<any>();
  tokenRef.current = token;

  const {
    get: getRequest,
    create: createRequest,
    remove: removeRequest,
  } = useFetch();

  const get = async (url: string, options?: {}) => {
    return await getRequest(
      url,
      tokenRef.current?.accessToken,
      () => renewToken(permission),
      {
        prefixUrl,
        ...options,
      }
    );
  };

  const create = async (url: string, payload: any, options: Options = {}) => {
    return await createRequest(
      url,
      payload,
      tokenRef.current?.accessToken,
      () => renewToken(permission),
      {
        prefixUrl,
        ...options,
      }
    );
  };

  const remove = async (url: string) => {
    return await removeRequest(
      url,
      tokenRef.current?.accessToken,
      () => renewToken(permission),
      {
        prefixUrl,
      }
    );
  };

  useEffect(() => {
    if (tokens[audience]?.accessToken) {
      tokenRef.current = tokens[audience];
      setToken(tokens[audience]);
      setIsLoading(false);
    }
  }, [tokens]);

  useEffect(() => {
    const fetch = async () => {
      requestAccessToken(permission);
    };

    if (!token) {
      fetch();
    }
  }, [requestAccessToken, token, permission]);

  return {
    isLoading,
    error: tokens[audience]?.tokenError,
    get,
    create,
    remove,
  };
}
